export function KpiChartCardSkeleton() {
  return (
    <div className="flex min-h-[406px] flex-col gap-3 rounded-[14px] border bg-card p-[21px]">
      <div className="skeleton-shimmer-bar h-4 w-48 rounded-md" />
      <div className="skeleton-shimmer-bar h-3 w-72 rounded-md" />
      <div className="mt-2 min-h-[332px]" aria-hidden />
    </div>
  );
}
